import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
  Output,
  EventEmitter,
  SimpleChanges} from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import {
  ClaimService,
  ClientService,
  InvoiceService,
  ToastMessageService,
} from '@fitness-force/api';
import { AppErrors, ErrorMsgComponent } from '@fitness-force/errors';

import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TimelineModule } from 'primeng/timeline';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PopoverModule } from 'primeng/popover';
import {
  Claim,
  Invoice,
  InvoiceById,
  InvoiceClient,
  NotificationError,
  PdfType,
  STAFFINTERFACE,
  TENANTSINTERFACE,
  voidInvoiceRequest,
} from '@fitness-force/models';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { InvoiceStatus, NotificationChannels } from '@fitness-force/enum';
import { combineLatestWith } from 'rxjs/operators';
import { DataGridComponent,EmptyStateContainerComponent} from '@fitness-force/grid';
import {  ActionsComponent} from '@fitness-force/grid-utility/action'
import { CurrencyComponent} from '@fitness-force/grid-utility/currency'
import { DateFormatedComponent} from '@fitness-force/grid-utility'
import { InvoiceStatusComponent } from '../../data-grid/utility/invoice-status/invoice-status.component';
import { ChangeBillOwnerComponent } from './change-bill-owner/change-bill-owner.component';
import { STAFF_STATE, TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { StaffInfoComponent } from '../../staff/staff-info/staff-info.component';
import { CreateSalesReturnComponent } from '@fitness-force/sales-return';
import { NumberPrefixComponent, PaymentComponent } from '@fitness-force/shared';
import { SkeletonModule } from 'primeng/skeleton';
import { WriteOffComponent } from './write-off/write-off.component';
import Statsig from 'statsig-js';
@Component({
  selector: 'invoice-tab',
  templateUrl: './invoice-tab.component.html',
  styleUrls: ['./invoice-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    DividerModule,
    TimelineModule,
    TableModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    RippleModule,
    SelectModule,
    AvatarModule,
    TagModule,
    StyleClassModule,
    DialogModule,
    PdfViewerModule,
    PopoverModule,
    DataGridComponent,
    ErrorMsgComponent,
    PaymentComponent,
    ChangeBillOwnerComponent,
    CreateSalesReturnComponent,
    SkeletonModule,
    WriteOffComponent,
    TranslateModule
],
})
export class InvoiceTabComponent implements OnInit {
  @Input('clientId') clientId = 0;
  @Input('tenantId') tenantId = 0;
  @Input('subscriptionId') subscriptionId = 0;
  @Input('showTableActions') showTableActions = true;
  @Input('showHeader') showHeader = true;
  @Output() tabAction : EventEmitter<{closePopup: boolean, reloadData:boolean}> = new EventEmitter();

  pdfSrc = new BehaviorSubject<string>('');
  showVoidInvoiceModal = false;
  showPayment = false;
  voidInvoiceForm: UntypedFormGroup = new UntypedFormGroup({});
  invoiceData$ = new BehaviorSubject<Invoice[]>([]);
  invoiceTablecolumns$ = new BehaviorSubject<any>([]);
  invoiceClientdataObject: BehaviorSubject<InvoiceClient> | any;
  selecallInvoiceData = false;
  invoiceDetailByClientId: InvoiceClient;
  showInvoicePopup = new BehaviorSubject(false);
  invoiceDetails: Invoice;
  showBulkActionBar = false;
  invoiceId = 0;
  invoiceDownloadUrl = '';
  invoiceFileName = '';
  showChangeBillOwner = new BehaviorSubject(false);
  createSalesReturn = new BehaviorSubject(false);
  emptyStateComponent$ = new BehaviorSubject<any>(EmptyStateContainerComponent);
  claim$: Observable<Claim[]> = new Observable();
  _filterStaff = new BehaviorSubject<number[]>([0]);
  _sessionOwner = new BehaviorSubject<number[]>([0]);
  accessedTenants:any;
  btnLoading=false;
  invoiceById:InvoiceById;
  invoiceParams: any = new Map();
  totalRecordLength = new BehaviorSubject({
    totalPage: 10,
    totalItems: 10,
    currentPage: 0,
  });
  totalItems$ = new BehaviorSubject(0);
  sendLinkCollectDues: boolean = false;
  emailSelected: boolean = false;
  smsSelected: boolean = false;
  whatsappSelected: boolean = false;
  loading: boolean = false;
  showWriteOff = new BehaviorSubject(false);
  showWriteOffList = new BehaviorSubject(false);
  showWriteOffOption = new BehaviorSubject(false);

  constructor(
    private store: Store,
    private translate: TranslateService,
    private clientService: ClientService,
    private toastMessageService: ToastMessageService,
    private invoiceService: InvoiceService,
    private fb: UntypedFormBuilder,
    private claimService: ClaimService,
    private toastService:ToastMessageService,
    private cd: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.invoiceParams.set('PageNumber', { name: 'PageNumber', value: 1 });
    this.invoiceParams.set('PageSize', { name: 'PageSize', value: 100 });
    this.loading = true;
    if (this.subscriptionId && this.subscriptionId > 0)
      this.GetSubscriptioInvoice();
    else this.GetInvoices();
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.accessedTenants = tenant.accessed_tenant;
    });
    if(Statsig.checkGate("show_writeoff")){
      this.showWriteOffOption.next(true);
    }
    else{
      this.showWriteOffOption.next(false);
    }
  }

  ngAfterViewInit() {
    this.voidInvoiceForm = this.fb.group({
      void_reason: ['', [Validators.required]],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle changes to the selectedOption input
    if (
      changes.subscriptionId &&
      changes.subscriptionId.currentValue != changes.subscriptionId.previousValue
    ) {
      this.GetSubscriptioInvoice();
    }
  }

  GetInvoices() {
    this.clientService.getClientInvoices(this.clientId, this.getInvoiceParams).subscribe({
      next: (data: any) => {
        this.totalRecordLength.next({
          totalPage: data.total_pages,
          totalItems: data.total_items,
          currentPage: data.current_page,
        });
        this.totalItems$.next(data.total_items);
        this.setClientInvoices(data.items ? data.items : []);

      },
      error: (error: AppErrors) => {
        this.setClientInvoices([]);
      },
    });
  }

  GetSubscriptioInvoice() {
    this.clientService
      .getSubscriptionInvoices(this.clientId, this.subscriptionId,this.getInvoiceParams)
      .subscribe({
        next: (data: any) => {
          this.totalRecordLength.next({
            totalPage: data.total_pages,
            totalItems: data.total_items,
            currentPage: data.current_page,
          });
          this.totalItems$.next(data.total_items);
          this.setClientInvoices(data.items ? data.items : []);
        },
        error: (error: AppErrors) => {
          this.setClientInvoices([]);
        },
      });
  }

  setClientInvoices(invoices: Invoice[]) {
    invoices.map((i) => {
      i.invoiceNumbers = [];
      i.invoiceNumbers.push(i.number_prefix);
    });
    this.invoiceData$.next(invoices);
    this.selecallInvoiceData = false;
    this.GetInvoiceTableColumns();
    this.loading = false;
  }

  GetInvoiceTableColumns() {
    this.translate
      .get([
        'INVOICE.COLUMNS.DATE',
        'INVOICE.COLUMNS.INVOICE',
        'INVOICE.COLUMNS.AMOUNT',
        'INVOICE.COLUMNS.BALANCE_DUE',
        'INVOICE.COLUMNS.WRITE_OFF',
        'INVOICE.COLUMNS.SALES_REP',
        'INVOICE.COLUMNS.STATUS'
  ])
      .subscribe((translations) => {
        this.ColumnsInvoiceTableTransalation(translations);
      });
  }

  ColumnsInvoiceTableTransalation(translations: any) {
    let Columns = {
      DATE: translations['INVOICE.COLUMNS.DATE'],
      INVOICE: translations[ 'INVOICE.COLUMNS.INVOICE'],
      AMOUNT: translations['INVOICE.COLUMNS.AMOUNT'],
      BALANCE_DUE: translations['INVOICE.COLUMNS.BALANCE_DUE'],
      WRITE_OFF: translations['INVOICE.COLUMNS.WRITE_OFF'],
      SALES_REP: translations['INVOICE.COLUMNS.SALES_REP'],
      STATUS: translations['INVOICE.COLUMNS.STATUS']
    };

    this.invoiceTablecolumns$.next([
      {
        title: Columns.DATE,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'issue_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: { KeyName: 'issue_date', format: 'd MMM y', applytimezone: true },
        },
      },
      {
        title: Columns.INVOICE,
        classes: 'py-3 white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'invoiceNumbers',
        type: 'component',
        data: {  
          name: NumberPrefixComponent,
          additionData: true,
          aData: { fetch_key: 'number_prefix', type: PdfType.Invoice,id:'id' }
        },
      },
      {
        title: Columns.AMOUNT,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'total_amount_in_minor_currency',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'total_amount_in_minor_currency',
        },
      },
      {
        title: Columns.BALANCE_DUE,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'total_balance_due_in_minor_currency',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'total_balance_due_in_minor_currency',
        },
      },
      {
        title: Columns.WRITE_OFF,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'total_write_off_amount_in_minor_currency',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'total_write_off_amount_in_minor_currency',
          isClickable: true,
        },

      },
      {
        title: Columns.SALES_REP,
        classes: ' py-2 white-space-nowrap',
        dataProperty: 'sales_representative',
        type: 'component',
        data: { name: StaffInfoComponent },
      },
      {
        title: Columns.STATUS,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'status',
        type: 'component',
        data: {
          name: InvoiceStatusComponent,
          additionData: true,
          aData: { fetch_key: 'status' },
        }
      }
    ]);

    if (this.showTableActions) {
      this.invoiceTablecolumns$.value.push({
        title: '',
        classes: 'py-2  white-space-nowrap',
        dataProperty: 'actions',
        type: 'component',
        data: {
          name: ActionsComponent,
          additionData: true,
          aData: [
            'print',
            'sendemail',
            'sendwhatsapp',
            'void',
            'collectdues',
            'changebillowner',
            'refundandsalesreturn',
            'balanceclear',
            'retrypayment',
            'writeoff'
          ],
        },
      });
    }
  }


  GetInvoicePdf(showInvoice: boolean) {
    let promise: Promise<boolean> = new Promise((resolve, reject) => {
      this.invoiceService
        .getInvoicePDF(this.clientId, this.invoiceId)
        .subscribe({
          next: (data: any) => {
            this.showInvoicePopup.next(showInvoice);
            this.pdfSrc.next(data.url);
            resolve(true);
          },
          error: (error: AppErrors) => {
            this.ShowToastErrors(error);
            resolve(false);
          },
        });
    });
    return promise;
  }

  onActionEvent(event: any) {
    switch (event.action) {
      case 'print':
        {
          this.invoiceId = event.columnData.id;
          this.invoiceDetails = event.columnData;
          this.GetInvoicePdf(false).then((res) => {
            this.printInvoice();
          });
        }
        break;
      case 'sendemail':
        this.invoiceId = event.columnData.id;
        this.SendInvoicePDF("Email");
        break;
      case 'sendwhatsapp':
      this.invoiceId = event.columnData.id;
      this.SendInvoicePDF("WhatsApp");
      break;
      case 'void':
        {
          this.invoiceId = event.columnData.id;
          this.invoiceDetails = event.columnData;
          if (this.invoiceDetails.status.toLocaleLowerCase() != InvoiceStatus.Void)
            this.showVoidInvoiceModal = true;
        }
        break;
      case 'collectdues':
        this.invoiceId = event.columnData.id;
        this.invoiceDetailByClientId = {} as InvoiceClient;
        this.invoiceDetailByClientId.client_id = event.columnData.client_id;
        this.invoiceDetailByClientId.invoice_id = event.columnData.id;
        this.invoiceDetailByClientId.tenant_id = event.columnData.tenant_id;
        this.invoiceDetailByClientId.company_id = event.columnData.company_id;
        this.invoiceClientdataObject = of(this.invoiceDetailByClientId);
        if (event.columnData.status.toLocaleLowerCase() != InvoiceStatus.Void)
          this.showPayment = true;
        break;
      case 'changebillowner':
        {
          this.invoiceId = event.columnData.id;
          this.invoiceDetails = event.columnData;
          this.filterStaff();
        }
        break;
      case 'refundandsalesreturn':
        {
          this.invoiceId = event.columnData.id;
          this.invoiceDetails = event.columnData;
          this.invoiceService.getInvoice(this.clientId, this.invoiceId)
          .subscribe({
            next: (data: any) => {
              this.invoiceById= data;
              this.createSalesReturn.next(true);
            },
          });
        }
        break;
      case 'writeoff':
        {
          this.invoiceId = event.columnData.id;
          this.invoiceDetails = event.columnData;
          this.showWriteOff.next(true);
          this.showWriteOffList.next(false);
        }
        break;
      case 'openWriteOffList':
        {
          if(this.showWriteOffOption.value)
          {
            this.invoiceId = event.columnData.id;
            this.invoiceDetails = event.columnData;
            this.showWriteOff.next(false);
            this.showWriteOffList.next(true);
          }
        }
        break;
      case 'updatedata':
        {
          this.ngOnInit();
        }
         break;
      case 'balanceclear':
        {
          this.invoiceId = event.columnData.id;
          this.invoiceDetails = event.columnData;
          this.sendLinkCollectDues = true;
          this.cd.detectChanges();
        }
        break;
      case 'retrypayment':
        {
          this.invoiceId = event.columnData.id;
          this.invoiceDetails = event.columnData;
          this.retryPayment();
          this.cd.detectChanges();
        }
        break;
    }
  }

  GetInvoiceDetails(invoiceNumber: string) {
    this.invoiceDetails = this.invoiceData$.value.find(
      (i) => i.number_prefix == invoiceNumber
    )!;
    this.invoiceId = this.invoiceDetails!.id;
    this.showInvoicePopup.next(true);
    this.GetInvoicePdf(true);
  }

  printInvoice() {
    window.open(this.pdfSrc.value, '_blank');
  }

  handleEvent(e: any) {}

  handleSelectAll(selection: any) {
    if (selection.checked) {
      this.showBulkActionBar = true;
    } else {
      this.showBulkActionBar = false;
    }
  }

  downloadInvoice() {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', this.pdfSrc.value);
    link.setAttribute('download', `invoice.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  SendInvoicePDF(channel:string) {
    let channels:any[]=[];
    channels.push(channel);
    this.invoiceService.SendInvoicePDF(this.clientId, this.invoiceId,channels).subscribe({
      next: (data: any) => {
        this.translate
          .get('TRANSACTION.MSG.INVOICE_MAIL_MSG')
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
      },
      error: (error: AppErrors) => {
        if(error.originalError.status == 200)
        {
            this.toastMessageService.showSuccess(error.originalError.error.text);
        }
        else if(error.originalError.error &&  Array.isArray(error.originalError.error) && error.originalError.error.length>0)
        {
          error.originalError.error.forEach((element: NotificationError) => {
            if(element.success)
              {
                this.translate.get('TRANSACTION.MSG.INVOICE_MAIL_MSG')
                .subscribe((translation) => {
                  this.toastMessageService.showSuccess(translation);
                });
              }
              else
              this.toastService.showErrorMessage(element.error.errorMessage);
          });
        }
        else{
          this.ShowToastErrors(error);
        }
      },
    });
  }

  deleteInvoice(form: UntypedFormGroup) {
    this.btnLoading= true;
    if (form.valid) {
      let voidRequest: voidInvoiceRequest = {} as voidInvoiceRequest;
      voidRequest.void_reason = form.value.void_reason;
      voidRequest.mark_void_payment=false;
      this.invoiceService.voidInvoice(this.invoiceDetails.tenant_id, this.clientId, this.invoiceId, voidRequest)
        .subscribe({
          next: (data: any) => {
            this.translate.get('TRANSACTION.MSG.INVOICE_VOID_MSG')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
            this.voidInvoiceForm.reset();
            this.invoiceDetails.status = InvoiceStatus.Void;
            let invoiceData = this.invoiceData$.value;
            invoiceData.forEach((inv) => {
              if (inv.id == this.invoiceDetails.id)
                inv.status = this.invoiceDetails.status;
            });
            this.invoiceData$.next(invoiceData);
            this.GetInvoiceTableColumns();
            this.btnLoading= false;
            this.showVoidInvoiceModal = false;
          },
          error: (error: AppErrors) => {
            this.btnLoading= false;
            this.toastService.showError(error);
            this.cd.detectChanges();
          },
        });
    } else {
      Object.keys(this.voidInvoiceForm.controls).forEach((field) => {
        const control = this.voidInvoiceForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      this.btnLoading= false;
    }
  }
  

  closeInvoicePopup() {
    this.showInvoicePopup.next(false);
  }

  ShowToastErrors(error: any) {
   this.toastService.showError(error);
  }

  filterStaff() {
    this.claim$ = this.claimService.GetClaim(environment.BASE_URL);
    let claim: Claim[] = {} as Claim[];
    let staffs: STAFFINTERFACE[] = [];
    let validStaff: number[] = [];
    this.claim$
      .pipe(combineLatestWith(this.store.select(STAFF_STATE)))
      .subscribe(([objClaim, objStaff]) => {
        claim = objClaim;
        staffs = objStaff.staffList;
        if (staffs.length > 0) {
          staffs.forEach((stf) => {
            if (
              claim.filter(
                (o) =>
                  o.id == stf.claim_template_id &&
                  (o.can_admin_billing == true || o.can_do_billing == true)
              ).length > 0
            )
              validStaff.push(stf.id);
          });
          this._filterStaff.next(validStaff);
        }
        this.showChangeBillOwner.next(true);
      });
  }

  get VoidReasonFormControl(): UntypedFormControl {
    return this.voidInvoiceForm.controls.void_reason as UntypedFormControl;
  }

  fetchNextSetData(e: any) {
    this.invoiceParams.set('PageNumber', { name: 'PageNumber', value: e.pn });
    this.invoiceParams.set('PageSize', { name: 'PageSize', value: e.ps });
    if (this.subscriptionId && this.subscriptionId > 0)
      this.GetSubscriptioInvoice();
    else this.GetInvoices();
  }

  GoToClientDetails(event: any) {
    this.showPayment = false;
  }

  HidePaymemt(event: any) {
    this.showPayment = false;
    this.GetInvoices();
  }

  closeDialogEvent(event:any)
  {
   this.showChangeBillOwner.next(false);
   this.showWriteOff.next(false);
   this.showWriteOffList.next(false);
  }

  closeWriteOffDialogEvent(event:{closePopup:boolean, reloadData:boolean})
  {
    this.showWriteOff.next(false);
    this.showWriteOffList.next(false);
    if(event.reloadData)
    {
      this.tabAction.emit({closePopup: true, reloadData : true}); 
      this.ngOnInit();
    }
  }

  closeSalesReturnDialogEvent(event:{closePopup:boolean, reloadData:boolean})
  {
    this.createSalesReturn.next(false);
    if(event.reloadData) this.tabAction.emit({closePopup: true, reloadData : true})
  }

  get getInvoiceParams(): Array<any> {
    return [...this.invoiceParams.values()];
  }

  SendCollectDuesLink(event: Event) {
    var service: any;
    let selectedChannels: NotificationChannels[] = [];

    if (this.emailSelected) {
      selectedChannels.push(NotificationChannels.Email);
    }
    if (this.smsSelected) {
      selectedChannels.push(NotificationChannels.SMS);
    }
    if (this.whatsappSelected) {
      selectedChannels.push(NotificationChannels.WhatsApp);
    }

    if (selectedChannels.length == 0) {
      this.translate
        .get('SUBSCRIPTIONS.MSG.SUBSCRIPTION_CHANNEL_NOTSELECTED')
        .subscribe((translation) => {
          this.toastService.showErrorMessage(translation);
        });
      return
    }

    service = this.invoiceService.InvoiceDueSendManageLink(this.tenantId,this.clientId,
      this.invoiceId, selectedChannels);

    service.subscribe({
      next: () => {
        this.translate
          .get('SUBSCRIPTIONS.MSG.INVOICE_SEND_MANAGELINK')
          .subscribe((translation) => {
            this.toastService.showSuccess(translation);
          });
        this.emailSelected = false;
        this.smsSelected = false;
        this.whatsappSelected = false;
        this.sendLinkCollectDues = false;
        this.cd.detectChanges();
      },
      error: (error: any) => {
        console.log(error);
        if(Array.isArray(error.originalError.error))
        {
          error.originalError.error.forEach((element: NotificationError) => {
            if(element.success)
            {
              if(element.channel.toLowerCase() == 'email')
              {
                this.translate.get('SUBSCRIPTIONS.MSG.EMAIL_LINK_SENT')
                .subscribe((translation) => {
                  this.toastService.showSuccess(translation,5000);
                });
              }
              else if(element.channel.toLowerCase() == 'sms')
              {
                this.translate.get('SUBSCRIPTIONS.MSG.SMS_LINK_SENT')
                .subscribe((translation) => {
                    this.toastService.showSuccess(translation,5000);
                });
              }
              else if(element.channel.toLowerCase() == 'whatsapp')
              {
                this.translate.get('SUBSCRIPTIONS.MSG.WHATSAPP_LINK_SENT')
                .subscribe((translation) => {
                  this.toastService.showSuccess(translation,5000);
                });
              }
              else{
                this.translate.get('SUBSCRIPTIONS.MSG.INVOICE_SEND_MANAGELINK')
              .subscribe((translation) => {
                  this.toastService.showSuccess(translation,5000);
                });
              }
            }
            else{
              this.toastService.showErrorMessage(element.error.errorMessage);
            }
          });
        }
        else{
          this.toastService.showError(error);
        }
        this.cd.detectChanges();
      },
    });
  }

  retryPayment() {
    this.invoiceService.RetryFailedPayment(this.invoiceDetails.tenant_id, this.clientId, this.invoiceId).subscribe({
      next: (data: any) => {
        this.translate
          .get('SUBSCRIPTIONS.PAYMENT_TIMELINE.RETRY_MSG')
          .subscribe((translation) => {
            this.toastService.showSuccess(translation);
          });
      },
      error: (error: AppErrors) => {
          this.toastService.showError(error);
      },
    });
  }

}
